import { UGData } from "./components/UFVForm";
import {
  producersDataToProducers,
  producersToProducersData,
} from "./componentsMapper";
import { PostUG, UG } from "./types";

export function ugDataToPostUG(ugData?: UGData): PostUG | undefined {
  if (!ugData) return undefined;
  const ug: PostUG = {
    number: ugData.number ?? undefined,
    disjuntorTag: ugData.disjuntorTag ?? undefined,
    hasTransformer: ugData.hasTransformer ?? undefined,
    hasSmartLogger: ugData.hasSmartLogger ?? undefined,
    components: {
      inverters: {
        amount: ugData.invertersAmount ?? undefined,
        inverterPower: ugData.inverterPower ?? undefined,
        producers: producersDataToProducers(
          ugData.invertersProducers ?? undefined
        ),
      },
      modules: {
        amount: ugData.modulesAmount ?? undefined,
        power: ugData.modulesPower ?? undefined,
        producers: producersDataToProducers(
          ugData.modulesProducers ?? undefined
        ),
      },
      string: {
        amount: ugData.stringAmount ?? undefined,
        power: ugData.stringPower ?? undefined,
      },
      trackers: {
        amount: ugData.trackersAmount ?? undefined,
        producers: producersDataToProducers(
          ugData.trackersProducers ?? undefined
        ),
      },
    },
  };
  return ug;
}

export function ugsDataToPostUGs(ugsData?: UGData[]): PostUG[] | undefined {
  if (!ugsData) return undefined;
  const ugs: PostUG[] = ugsData.map((ugData) => ugDataToPostUG(ugData)!);
  return ugs;
}

export function ugToUGData(ug?: UG): UGData | undefined {
  if (!ug) return undefined;
  console.log("ug", ug);
  const ugData: UGData = {
    number: getNumberOfUgName(ug.name),
    disjuntorTag: ug.disjuntorTag,
    hasTransformer: ug.hasTransformer,
    invertersAmount: ug.components.inverters?.amount,
    inverterPower: ug.components.inverters?.inverterPower,
    invertersProducers: producersToProducersData(
      ug.components.inverters?.producers
    ),
    modulesAmount: ug.components.modules?.amount,
    modulesPower: ug.components.modules?.power,
    modulesProducers: producersToProducersData(
      ug.components.modules?.producers
    ),
    stringAmount: ug.components.string?.amount,
    stringPower: ug.components.string?.power,
    trackersAmount: ug.components.trackers?.amount,
    trackersProducers: producersToProducersData(
      ug.components.trackers?.producers
    ),
  };
  return ugData;
}
export function ugsToPostUgs(ugs?: UG[]): PostUG[] | undefined {
  if (!ugs) return undefined;
  const ugsData: PostUG[] = ugs.map((ug) => ugToPostUG(ug)!);
  return ugsData;
}

export function ugToPostUG(ug?: UG): PostUG | undefined {
  if (!ug) return undefined;
  const ugData: PostUG = {
    number: getNumberOfUgName(ug.name),
    disjuntorTag: ug.disjuntorTag,
    hasTransformer: ug.hasTransformer,
    hasSmartLogger: ug.hasSmartLogger,
    components: ug.components,
  };
  return ugData;
}
export function ugsToUgsData(ugs?: UG[]): UGData[] | undefined {
  if (!ugs) return undefined;
  const ugsData: UGData[] = ugs.map((ug) => ugToUGData(ug)!);
  return ugsData;
}

export function postUgToUGData(ug?: PostUG): UGData | undefined {
  if (!ug) return undefined;
  const ugData: UGData = {
    number: ug.number,
    disjuntorTag: ug.disjuntorTag,
    hasTransformer: ug.hasTransformer,
    hasSmartLogger: ug.hasSmartLogger,
    invertersAmount: ug.components.inverters?.amount,
    inverterPower: ug.components.inverters?.inverterPower,
    invertersProducers: producersToProducersData(
      ug.components.inverters?.producers
    ),
    modulesAmount: ug.components.modules?.amount,
    modulesPower: ug.components.modules?.power,
    modulesProducers: producersToProducersData(
      ug.components.modules?.producers
    ),
    stringAmount: ug.components.string?.amount,
    stringPower: ug.components.string?.power,
    trackersAmount: ug.components.trackers?.amount,
    trackersProducers: producersToProducersData(
      ug.components.trackers?.producers
    ),
  };
  return ugData;
}

export function postUgsToUgsData(ugs?: PostUG[]): UGData[] | undefined {
  if (!ugs) return undefined;
  const ugsData: UGData[] = ugs.map((ug) => postUgToUGData(ug)!);
  return ugsData;
}

export function getNumberOfUgName(
  name: string | undefined
): number | undefined {
  const nameNumber = name?.match(/\d+/g);
  if (nameNumber) {
    return Number(nameNumber);
  }

  return undefined;
}
